<template>
  <div>
    <MobileMenu />
    <!-- BEGIN: Top Bar -->
    <div
      class="border-b border-theme-24 -mt-10 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 pt-3 md:pt-0 mb-10"
    >
      <div class="top-bar-boxed flex items-center">
        <!-- BEGIN: Logo -->
        <router-link
          :to="{ name: 'LiveG24' }"
          tag="a"
          class="-intro-x hidden md:flex"
        >
          <!-- <img
            alt=""
            class="w-6"
            src="@/assets/images/logo.png"
            style="width: 250px; height: 100px;"
          /> -->
          <span class="text-white text-lg ml-3"> LiveGame </span>
        </router-link>
        <!-- END: Logo -->
        <!-- BEGIN: Breadcrumb -->
        <!-- <div class="-intro-x breadcrumb breadcrumb--light mr-auto">
          <img
            alt=""
            class="w-6"
            src="@/assets/images/logo.png"
          />
        </div> -->
        <!-- END: Breadcrumb -->
        <!-- User Name -->
        <div class="intro-x relative mr-3 sm:mr-6 ml-auto">
          {{ this.$store.state.main.user.username }}
        </div>
        <!-- END: User Name -->
        <!-- Coin Amount -->
        <div class="intro-x relative mr-3 sm:mr-6 flex items-center justify-between">
          <img alt="coin" :src="require(`@/assets/images/coin.png`)" class="mr-2" />
          {{ this.$store.state.main.user.balance }}
        </div>
        <!-- BEGIN: Account Menu -->
        <div class="intro-x dropdown w-8 h-8 relative">
          <div
            class="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110"
          >
            <img alt="" :src="require(`@/assets/avatars/avatar.png`)" />
          </div>
        </div>
        <div class="intro-x relative mr-3 sm:mr-6" style="display: flex;background-color: #F3486A;align-items: center;gap: 15px;border-radius: 10px;left: 10px;">
          <a
            @click="logout()"
            href=""
            class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
          >
            Logout
          </a>
        </div>
        <!-- END: Account Menu -->
      </div>
    </div>
    <!-- END: Top Bar -->
    <!-- BEGIN: Top Menu -->
    <nav class="top-nav">
      <ul>
        <!-- BEGIN: First Child -->
        <template v-for="(menu, menuKey) in formattedMenu">
          <li :key="menuKey">
            <a
              href="javascript:;"
              class="top-menu"
              :class="{
                'top-menu--active': menu.active,
              }"
              @click="linkTo(menu)"
            >
              <div class="top-menu__icon">
                <component :is="menu.icon" />
              </div>
              <div class="top-menu__title">
                {{ menu.title }}
                <ChevronDownIcon
                  v-if="$h.isset(menu.subMenu)"
                  class="top-menu__sub-icon"
                />
              </div>
            </a>
            <!-- BEGIN: Second Child -->
            <ul v-if="$h.isset(menu.subMenu)">
              <li v-for="(subMenu, subMenuKey) in menu.subMenu" :key="subMenuKey">
                <a href="javascript:;" class="top-menu" @click="linkTo(subMenu)">
                  <div class="top-menu__icon">
                    <ActivityIcon />
                  </div>
                  <div class="top-menu__title">
                    {{ subMenu.title }}
                    <ChevronDownIcon
                      v-if="$h.isset(subMenu.subMenu)"
                      class="top-menu__sub-icon"
                    />
                  </div>
                </a>
                <!-- BEGIN: Third Child -->
                <ul v-if="$h.isset(subMenu.subMenu)">
                  <li
                    v-for="(lastSubMenu, lastSubMenuKey) in subMenu.subMenu"
                    :key="lastSubMenuKey"
                  >
                    <a href="javascript:;" class="top-menu" @click="linkTo(lastSubMenu)">
                      <div class="top-menu__icon">
                        <component :is="'zap-icon'" />
                      </div>
                      <div class="top-menu__title">
                        {{ lastSubMenu.title }}
                      </div>
                    </a>
                  </li>
                </ul>
                <!-- END: Third Child -->
              </li>
            </ul>
            <!-- END: Second Child -->
          </li>
        </template>
        <!-- END: First Child -->
      </ul>
    </nav>
    <!-- END: Top Menu -->
    <!-- BEGIN: Content -->
    <div class="content">
      <router-view />
    </div>
    <!-- END: Content -->
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import DarkModeSwitcher from "@/components/DarkModeSwitcher";

export default {
  components: {
    DarkModeSwitcher,
    MobileMenu,
    TopBar,
  },
  data() {
    return {
      formattedMenu: [],
      searchDropdown: false,
    };
  },
  computed: {
    topMenu() {
      return this.nestedMenu(this.$store.state.topMenu.menu);
    },
    username() {
      return this.$store.state.main.user?.username;
    },
  },
  watch: {
    $route() {
      this.formattedMenu = this.$h.assign(this.topMenu);
    },
    // 监听用户名的变化，当为空时调用登出
    username(newVal) {
      if (!newVal) {
        this.logout(); // 调用登出方法
      }
    },
  },
  mounted() {
    cash("body").removeClass("login").addClass("app");
    this.formattedMenu = this.$h.assign(this.topMenu);
    if (!this.username) {
      this.logout(); // 如果 username 为空，直接退出
    }
  },
  methods: {
    logout() {
      let self = this;
      self.$store.dispatch("main/logout");
      // self.$router.push({ name: "login" });
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) && this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu),
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach((item) => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (!match && this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu) {
  if (!this.$h.isset(menu.subMenu)) {
    if (this.$route.name !== menu.pageName) {
      this.$router.push({
        name: menu.pageName
      });
    }
  }
}

  }
};
</script>
